export class PreviewUserHasQualificationsResultDto {
  createCount: number;
  renewalCount: number;
  recyclingCount: number;
  renewalUserIds: string[];
  recyclingUserIds: string[];
}
